import { render, staticRenderFns } from "./RecruiterReport.vue?vue&type=template&id=3be38e1f&scoped=true&"
import script from "./RecruiterReport.vue?vue&type=script&lang=js&"
export * from "./RecruiterReport.vue?vue&type=script&lang=js&"
import style0 from "./RecruiterReport.vue?vue&type=style&index=0&id=3be38e1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be38e1f",
  null
  
)

export default component.exports